<template>
  <div id="artist-archive">
    <component :is="BaseArchiveTemplate">
      <template v-if="artists.length" #grid>
        <ArtistCard
          v-for="artist in artists"
          :key="artist.id"
          :artist-data="artist"
          :artist-type="setArtistType"
        />
        <div class="artist-card" />
        <div class="artist-card" />
        <div class="artist-card" />
      </template>
      <template v-if="artists.length" #loader>
        <Loading v-if="loading" color="black" />
      </template>
      <template v-if="isPageHasContent" #not-found>
        <NotFound />
      </template>
    </component>
    <template v-if="artists.length">
      <IntersectionObserver
        v-if="!loading && !noMoreDataToLoad"
        :init-observer="true"
        @intersect="loadArtistData"
      />
    </template>
  </div>
</template>
<script>
import BaseArchiveTemplate from '@/components/BaseArchiveTemplate.vue';
import ArchiveSubNav from '@/components/header/ArchiveSubNav.vue';
import ArchiveFilterLetter from '@/components/header/ArchiveFilterLetter.vue';
import axios from 'axios';
import configRoutes from '../router/configRoutes';
import ArtistCard from '@/components/cards/ArtistCard.vue';
import IntersectionObserver from '@/components/ui/IntersectionObserver.vue';
import Loading from '@/components/ui/Loading.vue';
import ArtistIndexList from '@/components/ui/ArtistIndexList';
import BaseFilterFrequency from '@/components/ui/BaseFilterFrequency.vue';
import NotFound from '@/components/errorHandlers/NotFound.vue';
export default {
  name: 'ArtistArchive',
  components: {
    BaseArchiveTemplate,
    ArchiveSubNav,
    ArchiveFilterLetter,
    ArtistCard,
    IntersectionObserver,
    Loading,
    ArtistIndexList,
    BaseFilterFrequency,
    NotFound
  },
  data: () => ({
    BaseArchiveTemplate: BaseArchiveTemplate,
    page: 0,
    pageSize: 12,
    totalPages: null,
    artists: [],
    initObserver: false,
    loading: true,
    routes: configRoutes.artistsRoutes,
    artistsRoutesEnum: {
      RESIDENTS: 'Residents',
      GUESTS: 'Guests'
    }
  }),

  computed: {
    setArtistType() {
      return this.$route.meta.artistType;
    },
    noMoreDataToLoad() {
      return this.page == this.totalPages - 1;
    },
    routeHasFrequency() {
      return this.$route.params.hasOwnProperty('frequency');
    },
    setLetterFilter() {
      return Object.keys(this.$route.params).length > 0 ? this.$route.params.id : 'all';
    },
    isPageHasContent() {
      return this.artists.length == 0 && this.loading == false;
    }
  },

  async mounted() {
    await this.loadArtistData();
    this.$nextTick(() => {
      this.initObserver = true;
    });
  },

  methods: {
    async loadArtistData() {
      this.loading = true;
      this.artists.length ? this.page++ : (this.page = 0);
      this.routeHasFrequency ? this.getArtistArchiveFrequency() : this.getArtistArchive();
    },

    getArtistArchive() {
      axios
        .get(
          `${this.$router.options.api}/artist/artist-type/${this.setLetterFilter}/?page=${this.page}&&size=${this.pageSize}&&artType=${this.setArtistType}`
        )
        .then(response => {
          this.totalPages = response.data.totalPages;
          this.artists = [...this.artists, ...response.data.content];
          this.loading = false;
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    },
    getArtistArchiveFrequency() {
      axios
        .get(
          `${this.$router.options.api}/artist/artist-type-frequency/${this.$route.params.id}/?page=${this.page}&&size=${this.pageSize}&&artType=Resident&frequency=${this.$route.params.frequency}`
        )
        .then(response => {
          this.totalPages = response.data.totalPages;
          this.artists = [...this.artists, ...response.data.content];
          this.loading = false;
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    }
  }
};
</script>
<style scoped lang="scss">
div#artist-archive {
  background-color: #e7e6e2;
}
.button-container {
  position: fixed;
  top: 70px;
  right: 10px;
}
</style>
